module.exports = __webpack_public_path__ + "static/media/imagemME.7b86a085.png";